class CategorySlider extends HTMLElement {
  constructor() {
    super();

    this.swiperInstance = null;
    this.spaceBetween = 2;
  }

  connectedCallback() {
    this.spaceBetween = this.getAttribute('data-space-between');
    this.initSwiper();
  }

  initSwiper() {
    this.swiperInstance = new Swiper(this, {
      slidesPerView: 3.5,
      preventInteractionOnTransition: true,
      spaceBetween: this.spaceBetween,
      slidesOffsetAfter: 12,
      slidesOffsetBefore: 12,
      watchOverflow: true,
      pagination: {
        el: '.swiper-pagination',
        type: 'progressbar',
      },
      breakpoints: {
        1025: {
          slidesPerView: 7.5,
          slidesOffsetAfter: 40,
          slidesOffsetBefore: 40,
        },
      },
    });
  }

  destroySwiper() {
    if (this.swiperInstance) {
      try {
        if (this.swiperInstance.destroyed) {
          console.info('Swiper already destroyed');

          this.swiperInstance = null;
          return null;
        }
        this.swiperInstance.destroy(true, true);
        this.swiperInstance = null;
      } catch (error) {
        console.error('Error destroying Swiper:', error);
        this.swiperInstance = null; // Fallback
      }
    } else {
      console.log('No Swiper instance to destroy');
    }
  }

  disconnectedCallback() {
    if (this.swiperInstance) {
      this.destroySwiper();
    }
  }
}

customElements.define('category-slider-controller', CategorySlider);
